import React, { useRef } from 'react';
import { Playable } from '@wix/wix-vod-player';
export const Player = _ref => {
  let {
    src,
    poster,
    onPlayerReady,
    onEnd
  } = _ref;
  const playerRef = useRef(null);
  const onPlayableInit = player => {
    if (!playerRef.current) {
      player.initSettings({
        qualityEnabled: true,
        speedEnabled: true
      });
      onPlayerReady && onPlayerReady(player);
      playerRef.current = player;
    }
  };
  return /*#__PURE__*/React.createElement(Playable, {
    src: src,
    onPlayableInit: onPlayableInit,
    coverUrl: poster,
    onEnd: onEnd
  });
};
//# sourceMappingURL=Player.js.map